import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { search } from '../../api/api';
import './gallery.css';
import Notification from '../../components/notification.js';

const Gallery = () => {
  const navigate = useNavigate();
  const [images, setImages] = useState([]);
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const ITEMS_PER_PAGE = 20;

  useEffect(() => {
    fetchUserImages();
  }, [page]);

  const fetchUserImages = async () => {
    try {
      const userId = localStorage.getItem('userId');
      console.log("userId", userId);
      if (!userId) {
        throw new Error('User ID not found');
      }

      setLoading(true);
      const response = await search({
        params: {
          generatedBy: userId,
          limit: ITEMS_PER_PAGE,
          skip: (page - 1) * ITEMS_PER_PAGE,
          sortBy: 'relevance',
          timeRange: 'all',
          aspectRatio: 'all',
          input: ''
        }
      });
      console.log("response", response);

      const newImages = response.data.results.items || [];
      setImages(prev => page === 1 ? newImages : [...prev, ...newImages]);
      setHasMore(newImages.length >= ITEMS_PER_PAGE);
      setLoading(false);
    } catch (error) {
      setNotification({
        type: 'error',
        message: 'Failed to load images. Please try again.'
      });
      setLoading(false);
      setHasMore(false);
    }
  };

  const handleImageClick = (image) => {
    if (!image || !image.publicId) {
      console.error('Invalid image data:', image);
      return;
    }
    navigate(`/explore?selected=${image.publicId}`);
  };

  const handleCloseNotification = () => {
    setNotification(null);
  };

  const handleLoadMore = () => {
    if (!loading && hasMore) {
      setPage(prev => prev + 1);
    }
  };

  const handleImageLoad = (event) => {
    const img = event.target;
    const ratio = img.naturalWidth / img.naturalHeight;
    const item = img.closest('.image-card');
    
    // Remove any existing ratio classes
    item.classList.remove('portrait', 'landscape', 'square');
    
    // Add appropriate ratio class
    if (ratio < 0.9) {
      item.classList.add('portrait');
    } else if (ratio > 1.1) {
      item.classList.add('landscape');
    } else {
      item.classList.add('square');
    }

    // Remove loading state
    item.style.opacity = '1';
  };

  if (loading && page === 1) {
    return <div className="gallery-loading">Loading...</div>;
  }

  return (
    <div className="gallery-container">
      <div className="gallery-content">
        <div className="gallery-header">
          <h1 className="gallery-title">My Generated Images</h1>
        </div>

        {images.length === 0 ? (
          <div className="empty-gallery">
            <p>You haven't generated any images yet.</p>
          </div>
        ) : (
          <>
            <div className="images-grid">
              {images.map(image => (
                <div key={image.publicId} className="image-card" onClick={() => handleImageClick(image)}>
                  <div className="image-wrapper">
                    <img 
                      src={image.path} 
                      alt={image.prompt || 'Generated image'}
                      onLoad={handleImageLoad}
                      loading="lazy"
                    />
                  </div>
                  <div className="image-info">
                    <p className="image-prompt">{image.prompt || 'Untitled'}</p>
                    <p className="image-date">{new Date(image.createdAt).toLocaleDateString()}</p>
                  </div>
                </div>
              ))}
            </div>

            {hasMore && !loading && (
              <div className="gallery-load-more">
                <button className="load-more-btn" onClick={handleLoadMore}>
                  Load More
                </button>
              </div>
            )}

            {loading && (
              <div className="gallery-loading">Loading more images...</div>
            )}
          </>
        )}
      </div>

      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={handleCloseNotification}
        />
      )}
    </div>
  );
};

export default Gallery; 